// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
import { colors } from "../../utils/theme/colors"
import Container from "../../components/layout/container"
import { LINKS } from "./constants"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const activeStyle = {
  color: colors.code.primary,
  transition: "width 0.3s eqse 0s",
}

const MobileNavigationPanel = ({ barHeight, langKey }) => {
  const data = useStaticQuery(graphql`
    query MenuMobileQuery {
      FRflag: file(relativePath: { eq: "france.png" }) {
        childImageSharp {
          fixed(width: 20, height: 20) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      UKflag: file(relativePath: { eq: "united-kingdom.png" }) {
        childImageSharp {
          fixed(width: 20, height: 20) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  return (
    <div
      sx={{
        backgroundColor: colors.code.secondary,
        width: `100%`,
        height: `100vh`,
        position: `fixed`,
        top: `0`,
        left: `0`,
        zIndex: `4`,
        willChange: `transform`,
        transform: `0.5s`,
        paddingTop: barHeight,
      }}
    >
      <Container
        overrideCSS={{
          height: "100%",
        }}
      >
        <ul
          sx={{
            display: `flex`,
            flexDirection: `column`,
            justifyContent: "center",
            alignItems: `center`,
            margin: 0,
            height: "100%",
          }}
        >
          {LINKS.map(link => (
            <Link
              key={link.to}
              to={
                (langKey === "en" ||
                !link.hasTranslation ||
                langKey === undefined
                  ? ""
                  : `/${langKey}`) + link.to
              }
              activeStyle={activeStyle}
              sx={{
                color: colors.white,
                textDecoration: `none`,
                fontSize: `1rem`,
                fontWeight: `600`,
                marginBottom: `2rem`,
              }}
            >
              {langKey === "en" ? link.contentEN : link.contentFR}
            </Link>
          ))}

          <div
            sx={{
              display: `flex`,
              width: `55px`,
              justifyContent: `space-between`,
            }}
          >
            <Link
              sx={{
                textDecoration: `none`,
              }}
              to={`/fr/`}
            >
              <Img alt="" fixed={data.FRflag.childImageSharp.fixed} />
            </Link>
            <Link
              sx={{
                textDecoration: `none`,
              }}
              to={"/"}
            >
              <Img alt="" fixed={data.UKflag.childImageSharp.fixed} />
            </Link>
          </div>
        </ul>
      </Container>
    </div>
  )
}

export default MobileNavigationPanel
